<div class="bottomsheet" (swipedown)="closeBottomSheet()">
    <div class="top-down" (click)="closeBottomSheet()"></div>
    <div class="topbar p-16">
        <mat-icon>campaign</mat-icon>
        <div class="ml-8">
            <p class="bold fs-18">{{ data?.Title }}</p>
            <div *ngIf="data.Projects.length" class="project-info">
                {{ data.Projects[0]?.Title }} | {{ data.Projects[0]?.AssignmentDate | date: 'EEE, dd.MM.yyyy' }}
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>

    <div class="announcement px-16 pb-12 w-100-p">
        <div class="fs-14 my-12" [innerHTML]="data?.Description"></div>

        <p class="fs-12">
            By {{ data?.AnnouncerName }} ({{ data?.AnnouncerRoles[0] }})
        </p>
    </div>

    <div *ngIf="data?.Documents && data?.Documents.length > 0" class="documents-section px-16 pb-12 w-100-p">
        <p class="bold fs-14">Attached Documents:</p>
        <div *ngFor="let document of data.Documents" class="document-item my-6">
            <div class="document-preview">
                <p class="document-title fs-12">{{ document?.Title }}</p>
                <a *ngIf="document?.Url" [href]="document.Url" target="_blank" class="view-link fs-12">
                    <mat-icon class="fs-12">visibility</mat-icon> <span class="fs-12">View</span>
                </a>
                <button mat-menu-item (click)="preview(document)" class="fs-12">
                    <mat-icon class="document-icon-color material-icons mr-12 fs-12">preview</mat-icon>
                    <span class="fs-12">{{ 'PREVIEW' | translate }}</span>
                </button>
                <button mat-menu-item (click)="download(document)" class="fs-12">
                    <mat-icon class="document-icon-color material-icons mr-12 fs-12">download</mat-icon>
                    <span class="fs-12">{{ 'DOWNLOAD' | translate }}</span>
                </button>
            </div>
        </div>
    </div>

</div>